import { render, staticRenderFns } from "./pagination-cmp.vue?vue&type=template&id=53ad6ec0&scoped=true"
import script from "./pagination-cmp.vue?vue&type=script&lang=js"
export * from "./pagination-cmp.vue?vue&type=script&lang=js"
import style0 from "./pagination-cmp.vue?vue&type=style&index=0&id=53ad6ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad6ec0",
  null
  
)

export default component.exports